import { render, staticRenderFns } from "./dprobanner.vue?vue&type=template&id=c3b7a4b0&scoped=true"
import script from "./dprobanner.vue?vue&type=script&lang=js"
export * from "./dprobanner.vue?vue&type=script&lang=js"
import style0 from "./dprobanner.vue?vue&type=style&index=0&id=c3b7a4b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b7a4b0",
  null
  
)

export default component.exports